export * from './../shared/vuex/map/getters'
import AWS from 'aws-sdk/global';

//Locale
export const getActiveLocale = state => state.activeLocale;

//Services
export const getServiceCategoriesRoot = ({map, listsAndItems}) => listsAndItems.find(c => c.id === map.lists.service_root_category);

export const getServiceCategories = ({listsAndItems}, getters) => {
    const rootCat = getters.getServiceCategoriesRoot;
    return rootCat ? _.orderBy(listsAndItems.filter(c => c.lft > rootCat.lft && c.lft <= rootCat.rgt), ['rgt'], ['asc']).filter(item => item.objectsCount > 0) : []
};
export const getServiceCategoriesAZ = (state, getters) => getters.getServiceCategories.sort((a, b) => getters.t(a, "name").localeCompare(getters.t(b, "name"), 'sv'));
export const getTerminalConfig = (state, getters) => _.has(getters.getTerminal, 'meta.customJSON') ? JSON.parse(getters.getTerminal.meta.customJSON) : {};
export const getServices = ({objects}, getters) => getters.getDenormalisedObjects.filter(item => item.type === getters.getMvData.config.categories['target_zone_service_category']);
export const getServicesObjects = ({objects}) => objects.filter((obj) => obj.type === 'service');

//Target zones

export const getTargetZones = ({listsAndItems, map}) => {
    return listsAndItems.filter(item => item['parent_id'] === map.lists['tenant_root_target_zone']);
};

//Map
export const getMap = ({map}) => map;

/**
 * Prepare map config, merge default with active theme and
 * additionally override with terminal specific settings if exist
 *
 * @return {object} map config
 */
export const getMapConfig = (state, getters) => {
    const resultConfig = {};

    const map = getters.getMap;
    if (!_.isEmpty(map.meta.themes)) {
        const {themes} = map.meta;
        let themeName = state.activeMapTheme || 'default';

        const themesChain = [];
        while (themeName) {
            const theme = themes.find(th => th.name === themeName);
            themesChain.push(theme);
            themeName = theme.parent
        }

        const terminalConfig = _.has(getters.getTerminal, 'meta.customJSON') ? JSON.parse(getters.getTerminal.meta.customJSON) : {};

        _.merge(resultConfig, ...themesChain.reverse(), terminalConfig)
    } else {
        // Backward compatibility
        const terminalConfig = _.has(getters.getTerminal, 'meta.customJSON') ? JSON.parse(getters.getTerminal.meta.customJSON) : {};
        const mapConfig = JSON.parse(_.get(getters.getMap, 'meta.mapsviewer.customJSON', '{}'))
        const integrationConfig = JSON.parse(_.get(getters.getMap, `meta.integrations[${getters.getIntegrationId}]`, '{}'));
        _.merge(resultConfig, mapConfig, terminalConfig, integrationConfig)
    }
    return resultConfig
};

/**
 * Get specific prop from map config
 *
 * @param {string} path - Path to the prop.
 * @param {string} def - Default value
 * @return {object} map config
 */
export const getMapConfigProp = (state, getters) => ( path, def = null) => {
    return _.get(getters.getMapConfig, path, def)
};
//Objects
export const getCategoryById = ({listsAndItems}) => (id) => listsAndItems.find(obj => obj.id === id);
export const getObject = ({objects}) => (object) => typeof object === 'object' ? object : objects.find((obj) => obj.id === object);
export const getObjectsByCategory = ({objects}) => (categoryId, listsProp = null) => objects.filter(
    (obj) => listsProp
        ? obj.lists[listsProp] && obj.lists[listsProp].includes(categoryId)
        : _.flatten(Object.values(obj.lists).filter(l => typeof l === 'object')).includes(categoryId)
);

export const getDenormalisedObjects = ({objects}, getters) => getters.denormaliseMapObjects(objects);
export const getDenormalisedObjectById = ({objects}, getters) => (id, unit = null) => getters.getDenormalisedObjects.find(obj => obj.id === id);
export const getDenormalisedObjectByIdAndUnit = ({objects}, getters) => (id, unit) => getters.getDenormalisedObjects.find(obj => obj.id === id && obj.unit.name === unit);
export const getDenormalisedObjectsById = ({objects}, getters) => (id) => getters.getDenormalisedObjects.filter(obj => obj.id === id);

export const getObjectPropById = ({objects}, getters) => (id, prop, def = null) => getters.t(getters.getDenormalisedObjectById(id), prop, def);
export const gop = ({objects}, getters) => (id, prop, def = null) => getters.t(getters.getDenormalisedObjectById(id), prop, def);

//Lists
export const getListItem = ({listsAndItems}) => (id) => listsAndItems.find(c => c.id === id);
export const getListChildren = ({listsAndItems}) => (parentId) => listsAndItems.filter(c => c.parent_id === parentId);
export const getListDescendants = ({listsAndItems}, getters) => (id) => {
    const rootCat = getters.getListItem(id)
    return rootCat ? listsAndItems.filter(c => c.lft > rootCat.lft && c.lft <= rootCat.rgt) : []
};
export const getRootCategories = ({ listsAndItems }) => listsAndItems.filter(c => c['parent_id'] === null);

//Tenants
export const getTenants = ({objects}) => objects.filter((obj) => obj.type === 'tenant');
export const getTenantsAZ = ({objects}, getters) => getters.getTenants.sort((a, b) => getters.t(a, "name").localeCompare(getters.t(b, "name"), 'sv'));
export const getTenantCategoriesRoot = ({ map, listsAndItems }) => listsAndItems.find(c => c.id === map.lists['tenant_root_category'])

// Models
export const getModels = ({models}) => models;

//Units
export const getUnitByName = ({units}) => (unitName) => units.find((u) => u.name === unitName);

// Floors
export const getFloors = ({objects}, getters) =>
    _.orderBy(
        getters.getDenormalisedObjects.filter((obj) => obj.type === 'floor'),
        [
            (f) => f.meta.building_index,
            (f) => f.meta.level,
        ], ['asc', 'desc']
    );

//Terminal
export const getTerminal = ({terminalId}, getters) => getters.getObject(terminalId);
export const getTerminalId = ({terminalId},) => terminalId;

//Portals
export const getMapViewerComponent = ({components}) => (props) => _.get(components.mapViewer, props, null);
export const isAppLoaded = ({appLoaded}) => appLoaded;

// unified way to get localised field of an object
export const t = ({activeLocale, defaultLocale, map}) => (object, field, defaultResult = '') => {

    if (!object)
        return defaultResult;

    // if object has direct field
    if (object[field] !== undefined)
        return object[field];

    // if object has translated field in meta
    if (object.meta) {

        if (object.meta[`${field}_${activeLocale}`] !== undefined && object.meta[`${field}_${activeLocale}`] !== null)
            return object.meta[`${field}_${activeLocale}`];

        if (object.meta[`${field}_${defaultLocale}`] !== undefined && object.meta[`${field}_${defaultLocale}`] !== null)
            return object.meta[`${field}_${defaultLocale}`];

        if (object.meta[field] !== undefined && object.meta[field] !== null )
            return object.meta[field];

        for (const el of map.meta.languages) {
            if (object.meta[`${field}_${el}`] !== undefined && object.meta[`${field}_${el}`] !== null)
                return object.meta[`${field}_${el}`];
        }
    }

    if (object.files) {
        if (object.files[field] !== undefined)
            return object.files[field]
    }

    return defaultResult
};

export const getMapLoading = state => state.mapLoading;

export const getMvData = (state, getters) => {
    const result = {};

    result.config = getters.getMapConfig;
    result.models = state.models;
    result.units = getters.getDenormalisedUnits;
    result.objects = getters.getDenormalisedObjects;
    result.b2bg = getters.getBuilding2GroupRelations

    if(state.terminalId)
        result.terminalUnitName = getters.getTerminal.unitNames[0];

    return result
};

export const getDenormalisedUnits = ({ map }, getters) => {
    return getters.getDenormalisedMapUnits(map.id, ['dae_unit','virtual_unit'])
};

export const isMobile = () => document.location.href.includes('mobile');
export const isTerminal = () => document.location.href.includes('/terminal-');

export const getSourceType = (state, getters) => {
    if (document.location.href.includes('terminal-') ) //Hospital ?
        return 'terminal';

    if (getters.isMobile)
        return 'mobile';
    return 'web'
};

export const getCategoryRoot = (state, getters) => (category) => {
    const cat = typeof category === 'number' ? getters.getListItem(category) : category;
    // Category is root category
    if (cat.parent_id === null)
        return cat;

    return getters.getRootCategories.find(c => c.lft < cat.lft && cat.lft < c.rgt)
};

export const getBaseEventData = (state, getters) => ({
    cid: 2, // 4 - Hospital
    mid: state.map ? state.map.id : null,
    tid: state.terminalId || null,
    uid: _.get(AWS, 'config.credentials.identityId', 'NotSet'),
    sid: state.sessionId,

    source: getters.getSourceType,
    source_id: state.terminalId
});
